export const COMMON_ANIMATION_OPTIONS = { allowWebkitAcceleration: true }
